
import React from "react";
import { RouteObject } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import Index from "@/pages/Index";
import Calendar from "@/pages/Calendar";
import WhyMediHub from "@/pages/WhyMediHub";
import Legal from "@/pages/legal/Legal";
import OrganizerGuide from "@/pages/OrganizerGuide";
import UpdateStream from "@/pages/UpdateStream";
import NotFound from "@/pages/NotFound";
import IndustryCalendarSolutions from "@/pages/IndustryCalendarSolutions";
import { sendPageView } from "@/services/analyticsService";

const PublicRoutes: RouteObject[] = [
  {
    path: "/",
    element: (
      <ProtectedRoute
        requireAuth={false}
        publicAccessible={true}
        onEnter={() => sendPageView("Főoldal")}
      >
        <WhyMediHub />
      </ProtectedRoute>
    )
  },
  {
    path: "/event/:eventSlug",
    element: (
      <ProtectedRoute 
        publicAccessible={true}
        onEnter={() => sendPageView("Esemény részletek")}
      >
        <Index />
      </ProtectedRoute>
    )
  },
  {
    path: "/calendar",
    element: (
      <ProtectedRoute 
        publicAccessible={true}
        onEnter={() => sendPageView("Naptár")}
      >
        <Calendar />
      </ProtectedRoute>
    )
  },
  {
    path: "/calendar/event/:eventSlug",
    element: (
      <ProtectedRoute 
        publicAccessible={true}
        onEnter={() => sendPageView("Naptár - Esemény")}
      >
        <Calendar />
      </ProtectedRoute>
    )
  },
  {
    path: "/why-medihub",
    element: (
      <ProtectedRoute 
        publicAccessible={true}
        onEnter={() => sendPageView("Miért MediHub")}
      >
        <WhyMediHub />
      </ProtectedRoute>
    )
  },
  {
    path: "/organizer-guide",
    element: (
      <ProtectedRoute 
        publicAccessible={true}
        onEnter={() => sendPageView("Szervezői útmutató")}
      >
        <OrganizerGuide />
      </ProtectedRoute>
    )
  },
  {
    path: "/industry-calendar-solutions",
    element: (
      <ProtectedRoute 
        publicAccessible={true}
        onEnter={() => sendPageView("Szakmai naptárrendszerek")}
      >
        <IndustryCalendarSolutions />
      </ProtectedRoute>
    )
  },
  {
    path: "/updates",
    element: (
      <ProtectedRoute 
        publicAccessible={true}
        onEnter={() => sendPageView("Frissítések")}
      >
        <UpdateStream />
      </ProtectedRoute>
    )
  },
  {
    path: "/legal",
    element: (
      <ProtectedRoute 
        publicAccessible={true}
        onEnter={() => sendPageView("Jogi információk")}
      >
        <Legal />
      </ProtectedRoute>
    )
  },
  {
    path: "/legal/:docType",
    element: (
      <ProtectedRoute 
        publicAccessible={true}
        onEnter={() => sendPageView("Jogi információk")}
      >
        <Legal />
      </ProtectedRoute>
    )
  },
  {
    path: "*",
    element: (
      <ProtectedRoute 
        publicAccessible={true}
        onEnter={() => sendPageView("404 - Nem található")}
      >
        <NotFound />
      </ProtectedRoute>
    )
  }
];

export default PublicRoutes;
